import { render, staticRenderFns } from "./PickingAssignment.vue?vue&type=template&id=af55c6f0"
import script from "./PickingAssignment.vue?vue&type=script&lang=js"
export * from "./PickingAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports